/* DSL Bulk-add — selecteer meerdere producten in collection-grid en voeg in 1 keer toe */
(function(){
  var selected = new Set();
  function refreshBar(){
    var bar = document.querySelector("[data-bulk-bar]");
    if (!bar) {
      if (selected.size === 0) return;
      bar = document.createElement("div");
      bar.className = "dsl-bulk-bar";
      bar.setAttribute("role","status");
      bar.dataset.bulkBar = "1";
      bar.innerHTML = "<span data-bulk-count></span> geselecteerd <button data-bulk-go>Voeg toe aan winkelwagen</button>";
      document.body.appendChild(bar);
    }
    bar.querySelector("[data-bulk-count]").textContent = selected.size;
    bar.hidden = selected.size === 0;
  }
  document.addEventListener("change", function(e){
    if (!e.target.matches("[data-bulk-select][type=checkbox]")) return;
    var vid = e.target.value;
    if (e.target.checked) selected.add(vid); else selected.delete(vid);
    refreshBar();
  });
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-bulk-go]")) return;
    var items = [...selected].map(function(id){ return {id: parseInt(id, 10), quantity: 1}; });
    if (!items.length) return;
    fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({items: items})}).then(function(){
      if (window.DSL_CART_DRAWER) window.DSL_CART_DRAWER.open();
      selected.clear();
      document.querySelectorAll("[data-bulk-select][type=checkbox]:checked").forEach(function(c){ c.checked = false; });
      refreshBar();
      if (window.DSL_AB) window.DSL_AB.track("bulk_add", {count: items.length});
    });
  });
})();